module.exports = __webpack_public_path__ + "static/media/13.e7781632.jpg";